import { render, staticRenderFns } from "./GeneralDoctor.vue?vue&type=template&id=709876c2&"
import script from "./GeneralDoctor.vue?vue&type=script&lang=js&"
export * from "./GeneralDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports